class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

    const facetButton = this.querySelector(".facets__button-show");
    const facetButtons = this.querySelectorAll(".facets__button-show");

    const facetsContainer = this.querySelector(".facets__container");
    if (facetsContainer) {
      setTimeout(() => {
        facetsContainer.style.display = "flex";
      }, 600);
    }

    if (facetButton) {
      const handleFacetButtonClick = (event) => {
        // Sync label state across all facets__button-show buttons
        const isOpen = !event.currentTarget.querySelector(".label-hide").classList.contains("hidden");
        facetButtons.forEach((btn) => {
          const lh = btn.querySelector(".label-hide");
          const ls = btn.querySelector(".label-show");
          if (isOpen) {
            lh?.classList.add("hidden");
            ls?.classList.remove("hidden");
          } else {
            lh?.classList.remove("hidden");
            ls?.classList.add("hidden");
          }
        });

        let container = event.currentTarget
          .closest("form")
          .querySelector(".facets__container");
        let section_container_coll = container.closest(
          ".shopify-section.collection-grid-section",
        );
        let section_container_search = container.closest(
          ".shopify-section.section-search",
        );
        section_container_coll?.classList.toggle("filter-shown");
        section_container_search?.classList.toggle("filter-shown");
        container.classList.toggle("active");
        document.body.classList.toggle(`overflow-hidden`);
        document.body.classList.toggle("filter-open");

        if (container.classList.contains("active")) {
          container.querySelectorAll(".facets__disclosure").forEach((d) => d.removeAttribute("open"));
          this.querySelectorAll(".filter-btn-item").forEach((b) => { if (!b.dataset.filterActive) b.classList.remove("active"); });
        }

        if (
          document.querySelector(
            ".facets__container--horizontal:not(.active)",
          ) != null
        ) {
          let horizontalFilters = document.querySelector(
            ".facets__container--horizontal:not(.active)",
          );
          horizontalFilters.classList.add("visible_container");

          setTimeout(
            () => horizontalFilters.classList.remove("visible_container"),
            600,
          );
        }

        container.addEventListener("click", () => {
          if (container.querySelector(".facets__wrapper:hover") == null) {
            let section_container_coll = container.closest(
              ".shopify-section.collection-grid-section",
            );
            let section_container_search = container.closest(
              ".shopify-section.section-search",
            );
            container.classList.remove("active");
            document.body.classList.remove(`overflow-hidden`);
            this.querySelectorAll(".filter-btn-item").forEach((b) => { if (!b.dataset.filterActive) b.classList.remove("active"); });
            facetButtons.forEach((btn) => {
              btn.querySelector(".label-hide")?.classList.remove("hidden");
              btn.querySelector(".label-show")?.classList.add("hidden");
            });
            setTimeout(() => {
              section_container_coll?.classList.remove("filter-shown");
              section_container_search?.classList.remove("filter-shown");
              document.body.classList.remove(`filter-open`);
            }, 700);
          }
        });
      };

      facetButtons.forEach((btn) => btn.addEventListener("click", handleFacetButtonClick));

      if (document.getElementById("SortBy") != null) {
        let select = document.getElementById("SortBy");
        select.addEventListener("click", () => select.classList.toggle("open"));
        select.addEventListener("blur", () => select.classList.remove("open"));
      }

      const facetCloseButton = this.querySelector(".facets-modal__close");
      facetCloseButton.addEventListener("click", () => {
        let container = facetCloseButton.closest(".facets__container");
        let section_container_coll = container.closest(
          ".shopify-section.collection-grid-section",
        );
        let section_container_search = container.closest(
          ".shopify-section.section-search",
        );
        container.classList.remove("active");
        document.body.classList.remove(`overflow-hidden`);
        this.querySelectorAll(".filter-btn-item").forEach((b) => { if (!b.dataset.filterActive) b.classList.remove("active"); });
        facetButtons.forEach((btn) => {
          btn.querySelector(".label-hide")?.classList.remove("hidden");
          btn.querySelector(".label-show")?.classList.add("hidden");
        });
        setTimeout(() => {
          section_container_coll?.classList.remove("filter-shown");
          section_container_search?.classList.remove("filter-shown");
          document.body.classList.remove(`filter-open`);
        }, 700);
      });

      const collectionGridSection =
        document.querySelector(".collection-grid-section") ||
        document.querySelector(".section-search");
      let prevWidth = 0;
      const sectionResizeObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
      });
      sectionResizeObserver.observe(collectionGridSection);
    }

    const filterBtnItems = this.querySelectorAll(".filter-btn-item");
    filterBtnItems.forEach((btn) => {
      btn.addEventListener("click", () => {
        const index = btn.dataset.index;
        const container = this.querySelector(".facets__container");
        if (!container) return;

        const targetDisclosure = container.querySelector(`.facets__disclosure[data-param="${index}"]`);
        const isAlreadyActive = btn.classList.contains("active") && container.classList.contains("active");

        filterBtnItems.forEach((b) => { if (!b.dataset.filterActive) b.classList.remove("active"); });
        container.querySelectorAll(".facets__disclosure").forEach((d) => d.removeAttribute("open"));

        if (isAlreadyActive) {
          container.classList.remove("active");
          document.body.classList.remove("overflow-hidden");
          const sectionColl = container.closest(".shopify-section.collection-grid-section");
          const sectionSearch = container.closest(".shopify-section.section-search");
          setTimeout(() => {
            sectionColl?.classList.remove("filter-shown");
            sectionSearch?.classList.remove("filter-shown");
            document.body.classList.remove("filter-open");
          }, 700);
        } else {
          if (!container.classList.contains("active")) {
            container.classList.add("active");
            document.body.classList.add("overflow-hidden");
            document.body.classList.add("filter-open");
            const sectionColl = container.closest(".shopify-section.collection-grid-section");
            const sectionSearch = container.closest(".shopify-section.section-search");
            sectionColl?.classList.add("filter-shown");
            sectionSearch?.classList.add("filter-shown");
          }
          if (targetDisclosure) {
            targetDisclosure.setAttribute("open", "");
          }
          btn.classList.add("active");
        }
      });
    });

    const filterContainer = this.querySelector(".facets__container");
    if (filterContainer) {
      filterContainer.addEventListener("click", () => {
        if (filterContainer.querySelector(".facets__wrapper:hover") == null) {
          filterBtnItems.forEach((b) => { if (!b.dataset.filterActive) b.classList.remove("active"); });
          filterContainer.classList.remove("active");
          document.body.classList.remove("overflow-hidden");
          const sectionColl = filterContainer.closest(".shopify-section.collection-grid-section");
          const sectionSearch = filterContainer.closest(".shopify-section.section-search");
          setTimeout(() => {
            sectionColl?.classList.remove("filter-shown");
            sectionSearch?.classList.remove("filter-shown");
            document.body.classList.remove("filter-open");
          }, 700);
        }
      });
    }

    this.querySelectorAll(".facets__disclosure").forEach((details) => {
      details.addEventListener("toggle", () => {
        const idx = details.dataset.param;
        filterBtnItems.forEach((btn) => {
          if (btn.dataset.index === idx) {
            btn.classList.toggle("active", details.open);
          }
        });
      });
    });

    this.querySelectorAll(".facets__disclosure[data-param]").forEach((details) => {
      details.addEventListener("change", () => {
        const param = details.dataset.param;
        const btn = [...filterBtnItems].find((b) => b.dataset.index === param);
        if (!btn) return;
        const hasChecked = !!details.querySelector('input[type="checkbox"]:checked');
        if (hasChecked) {
          btn.dataset.filterActive = "true";
          btn.classList.add("active");
        } else {
          delete btn.dataset.filterActive;
        }
      });
    });

    const checkboxes = document.querySelectorAll(
      '#FacetFiltersFormMobile .js-filter input[type="checkbox"]',
    );
    const removebtn = document.querySelector(
      "#FacetFiltersFormMobile .facets-tag-wrapper",
    );
    const allChecked = Array.from(checkboxes).some(
      (checkbox) => checkbox.checked,
    );

    if (allChecked) {
      removebtn?.classList.remove("active");
    } else {
      removebtn?.classList.add("active");
    }

    const sortingWrapper = this.querySelector(".facet-filters.facets-sorting.sorting");
    const customOptions = this.querySelector(".custom-options");
    const sortSelect = this.querySelector(".select__select.secondary_text");

    if (sortingWrapper) {
      sortingWrapper.addEventListener("click", (e) => {
        const opts = sortingWrapper.querySelector(".custom-options");
        const sel = sortingWrapper.querySelector(".select__select");
        if (!opts || !sel) return;

        if (e.target.closest(".facets-sorting__label")) {
          e.preventDefault();
        }

        const clickedLi = e.target.closest(".custom-options li");
        if (clickedLi) {
          sel.value = clickedLi.dataset.value;
          opts.querySelectorAll("li").forEach((l) => l.classList.remove("selected"));
          clickedLi.classList.add("selected");
          opts.style.display = "none";
          const liText = clickedLi.textContent.trim();
          const sortLabelText = sortingWrapper.querySelector(".sort-label-text");
          let activeSort = sortingWrapper.querySelector(".active-sort");
          if (liText === "Featured") {
            if (sortLabelText) sortLabelText.style.display = "";
            if (activeSort) activeSort.style.display = "none";
          } else {
            if (sortLabelText) sortLabelText.style.display = "none";
            if (!activeSort) {
              activeSort = document.createElement("span");
              activeSort.className = "active-sort";
              const sortLabel = sortingWrapper.querySelector(".facets-sorting__label");
              if (sortLabel) sortLabel.appendChild(activeSort);
            }
            activeSort.style.display = "";
            activeSort.textContent = liText;
          }
          sel.dispatchEvent(new Event("input", { bubbles: true }));
          return;
        }

        const isHidden = !opts.style.display || opts.style.display === "none";
        opts.style.display = isHidden ? "block" : "none";
      });

      document.addEventListener("click", (e) => {
        if (!sortingWrapper.contains(e.target)) {
          const opts = sortingWrapper.querySelector(".custom-options");
          if (opts) opts.style.display = "none";
        }
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        FacetFiltersForm.rerenderProductSliders();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.rerenderProductSliders();
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
    if (
      document.querySelector(".js-load-more") ||
      document.querySelector(".js-infinite-scroll")
    )
      loadMore();

    colorSwatches();
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );

    const checkboxes = document.querySelectorAll(
      '#FacetFiltersFormMobile .js-filter input[type="checkbox"]',
    );
    const removebtn = document.querySelector(
      "#FacetFiltersFormMobile .facets-tag-wrapper",
    );
    const allChecked = Array.from(checkboxes).some(
      (checkbox) => checkbox.checked,
    );

    if (allChecked) {
      removebtn?.classList.remove("active");
    } else {
      removebtn?.classList.add("active");
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  static rerenderProductSliders() {
    const sliders = document.querySelectorAll(".product-card-js");

    sliders.forEach((slider) => {
      new Swiper(slider, {
        pagination: {
          el: ".product-pagination .swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".product-button-group .swiper-button-next",
          prevEl: ".product-button-group .swiper-button-prev",
        },
        allowTouchMove: true,
        990: {
          allowTouchMove: false,
        },
      });
    });
  }

  createSearchParams(form) {
    // const formData = new FormData(form);
    // return new URLSearchParams(formData).toString();
    const formData = new FormData(form);
    const currentParams = new URLSearchParams(window.location.search);
		console.log('form data and current params:',formData, currentParams.toString())
    // Capture the vendor value before mutation so we can detect a change
    const previousVendor = currentParams.get("filter.p.vendor");
    // Detect an explicit "All" vendor selection: the field is submitted but empty.
    // Empty values are skipped below, and filter.p.vendor is otherwise preserved,
    // so without this the vendor filter can never be cleared.
    const vendorSubmitted = formData.has("filter.p.vendor");
    const vendorSelectedValue = formData.get("filter.p.vendor");
    // Collect values per key
    const keyValues = {};
    for (const [key, value] of formData.entries()) {
      if (!value) continue;
      if (!keyValues[key]) {
        keyValues[key] = [];
      }
      keyValues[key].push(value);
    }

    // Remove filter keys in currentParams that are no longer in formData
    for (const key of [...currentParams.keys()]) {
			console.log('pengecekan key',key)
			console.log('pengecekan key val',currentParams[key])
      if (key.startsWith('filter.') && key !== 'filter.p.vendor' && !keyValues[key]) {
        currentParams.delete(key);
      }
    }

    // Apply to currentParams
    for (const [key, values] of Object.entries(keyValues)) {
      currentParams.delete(key);
      if (key === "filter.p.vendor") {
        // For vendor, only allow one unique value
        const uniqueValues = [...new Set(values)];
        if (uniqueValues.length > 0) {
          currentParams.append(key, uniqueValues[0]); // Take only the first unique value
        }
      } else {
        // For other filters, allow multiple values
        values.forEach((value) => currentParams.append(key, value));
      }
    }

    // "All" selected (vendor field present but empty): clear the vendor filter
    // so results are returned regardless of vendor.
    if (vendorSubmitted && !vendorSelectedValue) {
      currentParams.delete("filter.p.vendor");
    }

    // Reset pagination when the vendor filter changes
    const newVendor = currentParams.get("filter.p.vendor");
    if (newVendor !== previousVendor) {
      currentParams.delete("page");
    }

    return currentParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form"),
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const currentForm = event.target.closest("form");
      sortFilterForms.forEach((form) => {
        if (
          form.id === "FacetSortForm" ||
          form.id === "FacetFiltersForm" ||
          form.id === "FacetFiltersFormMobile" ||
          form.id === "FacetSortDrawerForm" ||
          // added by yudi
          form.id === "FacetFiltersFormQuickFilter"
        ) {
          const noJsElements = document.querySelectorAll(".no-js-list");
          noJsElements.forEach((el) => el.remove());
          if (currentForm === form) {
            forms.push(this.createSearchParams(form));
          } else {
            // edited by Yudi
            // const searchParamsWithoutProductType = this.createSearchParams(form)
            // ?.split('&')
            // ?.filter((element) => !element.startsWith('filter.p.product_type'))
            // ?.join('&') || '';
            // console.log('bottom',searchParamsWithoutProductType)
            // forms.push(searchParamsWithoutProductType)
          }
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);

    // const checkboxes = document.querySelectorAll('#FacetFiltersFormMobile .js-filter input[type="checkbox"]');
    const removebtn = document.querySelector(
      "#FacetFiltersFormMobile .facets-tag-wrapper",
    );
    // const allChecked = Array.from(checkboxes).every(checkbox => !checkbox.checked);
    removebtn?.classList.add("active");

    // if (allChecked) {
    // 	console.log("All checkboxes are checked.");
    // } else {
    // 	console.log("Not all checkboxes are checked.");
    // }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
		console.log('value adjusted')
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range",
    );
    inputRangeWrappers.forEach((inputWrapper) => {
      const inputsRange = inputWrapper.querySelectorAll(".field__range");
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = (fromCurrent / range) * 100;
      const maxRange = (toCurrent / range) * 100;

      inputWrapper.setAttribute(
        "style",
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`,
      );
    });
  }

  controlSlider() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range",
    );
    const inputNumberWrappers = document.querySelectorAll(
      ".facets__price .facets__price-wrapper",
    );

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll(".field__range");
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom =
        inputNumberWrappers[index].querySelectorAll(".field__input")[0];
      const inputNumberTo =
        inputNumberWrappers[index].querySelectorAll(".field__input")[1];

      inputRangeFrom.onchange = () => {
        const from = parseInt(inputRangeFrom.value, 10) || 0;
        const to = parseInt(inputRangeTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } else {
          inputNumberFrom.value = from;
        }

        this.fillSlider();
      };

      if (Number(inputRangeTo.value) <= 0) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.onchange = () => {
        const from = parseInt(inputRangeFrom.value, 10) || 0;
        const to = parseInt(inputRangeTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        } else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      };
    });
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range",
    );
    const inputNumberWrappers = document.querySelectorAll(
      ".facets__price .facets__price-wrapper",
    );

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll(".field__input");
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom =
        inputRangeWrappers[index].querySelectorAll(".field__range")[0];
      const inputRangeTo =
        inputRangeWrappers[index].querySelectorAll(".field__range")[1];

      inputNumberFrom.onchange = () => {
        const from = parseInt(inputNumberFrom.value, 10) || 0;
        const to = parseInt(inputNumberTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      };

      inputNumberTo.onchange = () => {
        const from = parseInt(inputNumberFrom.value, 10) || 0;
        const to = parseInt(inputNumberTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        } else {
          inputNumberTo.value = from;
        }

        this.fillSlider();
      };
    });
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
